"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var index_1 = require("../../../../../Atoms/index");
var phoneValidation_1 = require("../../utils/phoneValidation");
var PhoneInput = (0, react_1.forwardRef)(function (_a, ref) {
    var id = _a.id, value = _a.value, placeholder = _a.placeholder, disabled = _a.disabled, error = _a.error, isAnswered = _a.isAnswered, isSafari = _a.isSafari, isAutoFilledActive = _a.isAutoFilledActive, experimentName = _a.experimentName, _b = _a.type, type = _b === void 0 ? 'tel' : _b, onChange = _a.onChange, onBlur = _a.onBlur, onClick = _a.onClick, strictMode = _a.strictMode, props = __rest(_a, ["id", "value", "placeholder", "disabled", "error", "isAnswered", "isSafari", "isAutoFilledActive", "experimentName", "type", "onChange", "onBlur", "onClick", "strictMode"]);
    var internalRef = (0, react_1.useRef)(null);
    var cursorPositionRef = (0, react_1.useRef)(null);
    var previousValueRef = (0, react_1.useRef)(value);
    var inputRef = ref || internalRef;
    // Restore cursor position after value changes
    (0, react_1.useEffect)(function () {
        if (cursorPositionRef.current !== null &&
            inputRef &&
            'current' in inputRef &&
            inputRef.current &&
            previousValueRef.current !== value) {
            var newCursorPos_1 = (0, phoneValidation_1.calculateCursorPosition)(previousValueRef.current, value, cursorPositionRef.current);
            setTimeout(function () {
                if (inputRef && 'current' in inputRef && inputRef.current) {
                    inputRef.current.setSelectionRange(newCursorPos_1, newCursorPos_1);
                }
            }, 0);
            cursorPositionRef.current = null;
        }
        previousValueRef.current = value;
    }, [value, inputRef]);
    var sanitizeStrict = function (raw) {
        var MAX_DIGITS = 15; // E.164 allows up to 15 digits
        var input = raw || '';
        var cleaned = input.replace(/[^\d+]/g, '');
        if (cleaned.startsWith('+')) {
            var digitsOnly_1 = cleaned
                .slice(1)
                .replace(/\+/g, '')
                .replace(/[^\d]/g, '');
            return "+".concat(digitsOnly_1.slice(0, MAX_DIGITS));
        }
        var digitsOnly = cleaned.replace(/\+/g, '').replace(/[^\d]/g, '');
        return digitsOnly.slice(0, MAX_DIGITS);
    };
    var handleChange = function (params) {
        if (inputRef && 'current' in inputRef && inputRef.current) {
            cursorPositionRef.current = inputRef.current.selectionStart;
        }
        if (!strictMode) {
            onChange(params);
            return;
        }
        onChange({ id: params.id, value: sanitizeStrict(params.value) });
    };
    return ((0, jsx_runtime_1.jsx)(index_1.Input, __assign({ error: error, id: id, onChange: handleChange, valueTransform: strictMode ? sanitizeStrict : undefined, isAnswered: isAnswered !== null && isAnswered !== void 0 ? isAnswered : false, value: value, isSafari: isSafari !== null && isSafari !== void 0 ? isSafari : false, isAutoFilledActive: isAutoFilledActive !== null && isAutoFilledActive !== void 0 ? isAutoFilledActive : false, experimentName: experimentName !== null && experimentName !== void 0 ? experimentName : '', type: type, placeholder: placeholder, inputRef: inputRef, disabled: disabled, onBlur: onBlur, onClick: onClick, "aria-invalid": error }, props)));
});
PhoneInput.displayName = 'PhoneInput';
exports.default = PhoneInput;
//# sourceMappingURL=PhoneInput.js.map